import { render, staticRenderFns } from "./SimpleProposal.vue?vue&type=template&id=20cd6302&"
import script from "./SimpleProposal.vue?vue&type=script&lang=js&"
export * from "./SimpleProposal.vue?vue&type=script&lang=js&"
import style0 from "./SimpleProposal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports